import { buildChatShareUrl } from "@frontend-shared/utils";

// NOTE: The URL itself is built in frontend-shared so a link created on mobile
// points at exactly the same viewer (NSAI-4322); web only supplies its origin.
export const buildShareUrl = (shareToken: string): string =>
  buildChatShareUrl({ origin: globalThis.location.origin, shareToken });
